import axiosInstance from "../api/axiosInstance";

export async function getAvailableSlotsByDate(year, month, day) {
  try {
    const response = await axiosInstance.get(
      `/booking/getAvailableSlots/${year}/${month}/${day}`
    );
    return response.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export const searchExistingBooking = async (phoneNumber, emailAddress) => {
  try {
    const response = await axiosInstance.post(
      `/booking/getTokenByContactDetails`,
      {
        phoneNumber,
        emailAddress,
      }
    );
    return response.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const validateForm = async (formData) => {
  try {
    const response = await axiosInstance.post(`/booking/validateForm`, formData);
    return response.data;
  } catch (err) {
    // On failure, allow the user to proceed (validation is optional)
    return { success: true, errors: null, bookingWindow: null };
  }
};

export const getEffectiveBookingWindow = async (userData = null) => {
  try {
    if (userData) {
      const response = await axiosInstance.post(`/booking/getEffectiveBookingWindow`, userData);
      return response.data;
    }
    const response = await axiosInstance.get(`/booking/getEffectiveBookingWindow`);
    return response.data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

const monthlyDataCache = new Map();
export const getMonthlyData = async (year, month) => {
  const key = `${year}-${month}`;
  if (monthlyDataCache.has(key)) return monthlyDataCache.get(key);
  const promise = axiosInstance
    .get(
      `/booking/getMonthlyData/${year}/${month}`
    )
    .then((res) => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    })
    .finally(() => {
      monthlyDataCache.delete(key);
    });

  monthlyDataCache.set(key, promise);
  return promise;
};

export const addBooking = async (body) => {
  try {
    const response = await axiosInstance.post(
      `${process.env.REACT_APP_BOOKING_API_URL}/booking/addBooking`,
      body
    );
    return response;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getDailyData = async (day, month, year) => {
  try {
    const dailyData = await axiosInstance.get(
      `${process.env.REACT_APP_BOOKING_API_URL}/booking/getDailyData/${year}/${month}/${day}`
    );
    return dailyData.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const updateBookingDate = async (bookingId, body) => {
  try {
    const response = await axiosInstance.put(
      `${process.env.REACT_APP_BOOKING_API_URL}/booking/updateBooking/${bookingId}`,
      body
    );
    return response;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const deleteBooking = async (bookingId, token) => {
  try {
    await axiosInstance.delete(
      `${process.env.REACT_APP_BOOKING_API_URL}/booking/deleteBooking/${bookingId}/${token}`
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const searchForBooking = async (token) => {
  try {
    const response = await axiosInstance.get(
      `${process.env.REACT_APP_BOOKING_API_URL}/booking/getBookingByToken/${token}`
    );
    return response;
  } catch (err) {
    console.error(err);
    throw err;
  }
};
